import { render } from "./PublishEventCard.vue?vue&type=template&id=3162fb6a"
import script from "./PublishEventCard.vue?vue&type=script&lang=js"
export * from "./PublishEventCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__